"use client";
import { motion } from "framer-motion";
import Link from "next/link";
import { useTranslations } from "next-intl";

const Services = () => {
  const calendlyUrl = "https://calendly.com/parthkalani9282/30min";
  const upworkUrl = "https://www.upwork.com/freelancers/parthk24";
  const t = useTranslations("services");

  return (
    <section className="min-h-[80vh] py-12 xl:py-0">
      <div className="container mx-auto">
        <h1 className="sr-only">Freelance Call To Action</h1>

        <div className="sticky top-4 z-20 mb-8 rounded-2xl border border-white/10 bg-primary/90 p-3 backdrop-blur">
          <div className="flex flex-col gap-3 sm:flex-row">
            <Link
              href={calendlyUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-target rounded-xl bg-accent px-6 py-3 text-center font-semibold text-primary transition-all duration-300 hover:bg-accent-hover"
            >
              {t("bookCall")}
            </Link>
            <Link
              href={upworkUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-target rounded-xl border border-white/20 px-6 py-3 text-center font-semibold text-white transition-all duration-300 hover:border-accent hover:text-accent"
            >
              {t("hireMe")}
            </Link>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{
            opacity: 1,
            y: 0,
            transition: { duration: 0.4, ease: [0.22, 1, 0.36, 1] },
          }}
          className="relative mx-auto max-w-4xl overflow-hidden rounded-3xl border border-white/10 bg-white/5 p-6 shadow-2xl shadow-black/30 backdrop-blur-sm md:p-10"
        >
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(255,255,255,0.08),transparent_45%),radial-gradient(circle_at_bottom_left,rgba(255,185,70,0.14),transparent_40%)]" />
          <div className="relative space-y-6">
            <div className="inline-flex items-center rounded-full border border-accent/30 bg-accent/10 px-4 py-1 text-xs font-medium uppercase tracking-wider text-accent">
              {t("badge")}
            </div>
            <h2 className="text-3xl font-bold text-white md:text-5xl">
              {t("title")}
            </h2>

            <p className="text-lg text-white/80">
              {t("description")}
            </p>

            <div className="grid gap-3 text-white/80 md:grid-cols-3">
              <div className="rounded-xl border border-white/10 bg-black/20 p-4">
                <p className="font-semibold text-white">{t("card1Title")}</p>
                <p className="text-sm text-white/70">
                  {t("card1Description", { platform: "Calendly" })}
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-black/20 p-4">
                <p className="font-semibold text-white">{t("card2Title")}</p>
                <p className="text-sm text-white/70">
                  {t("card2Description")}
                </p>
              </div>

              <div className="rounded-xl border border-white/10 bg-black/20 p-4">
                <p className="font-semibold text-white">{t("card3Title")}</p>
                <p className="text-sm text-white/70">
                  {t("card3Description")}
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-3 pt-1 sm:flex-row">
              <Link
                href={calendlyUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="cursor-target rounded-xl bg-accent px-6 py-3 text-center font-semibold text-primary transition-all duration-300 hover:-translate-y-0.5 hover:bg-accent-hover hover:shadow-lg hover:shadow-accent/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-background"
              >
                {t("bookFreeCall")}
              </Link>
              <Link
                href={upworkUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="cursor-target rounded-xl border border-white/20 px-6 py-3 text-center font-semibold text-white transition-all duration-300 hover:-translate-y-0.5 hover:border-accent hover:text-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-background"
              >
                {t("card2Title")}
              </Link>
              <Link
                href="/contact"
                className="cursor-target rounded-xl border border-white/20 px-6 py-3 text-center font-semibold text-white transition-all duration-300 hover:-translate-y-0.5 hover:border-accent hover:text-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-background"
              >
                {t("contactMe")}
              </Link>
            </div>

            <p className="rounded-lg border border-white/10 bg-black/20 px-4 py-3 text-sm text-white/70">
              {t("quickResponse")}
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
